export default __webpack_public_path__ + "static/media/BuenFin23(1440x600).77f2a083.webp";